import React, { useState } from 'react'
import { Link } from 'react-router-dom'

function CopyItem() {

  const [cardData] = useState([
    {
      name: 'Shisha',
      path: 'products'
    },
    {
      name: 'Burger'
    },
    {
      name: 'Sweet'
    },
    {
      name: 'Pakage 28'
    },
    {
      name: 'Pakage 15'
    },
    {
      name: 'Pakage 19'
    },
  ])


  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div>
          <h1 className="text-[#7B20C7] text-2xl font-semibold py-5">Categories</h1>
        </div>
        <div className="flex flex-wrap gap-6">
          {cardData &&
            cardData.map((data) => (
              <Link to={data.path} className="border-solid border-2 border-[#7B20C7] p-6 cursor-pointer rounded-2xl w-36 hover:transition-all hover:bg-[#7B20C7] group ">
                <div>
                  <h1 className="flex justify-center align-middle   text-md font-semibold
                 group-hover:text-white ">{data.name}</h1>
                </div>
              </Link>
            ))}
        </div>
      </div>
    </main>
  )
}

export default CopyItem
